export const DDS_MITIGATION_SOURCE_TYPE = {
  LOCAL_DB_COMPLIANCE: 'local_db_compliance',
  EUDR_DEFORESTATION: 'eudr_deforestation',
};

const GRAPHQL_ENUM_BY_CANONICAL = {
  [DDS_MITIGATION_SOURCE_TYPE.LOCAL_DB_COMPLIANCE]: 'LOCAL_DB_COMPLIANCE',
  [DDS_MITIGATION_SOURCE_TYPE.EUDR_DEFORESTATION]: 'EUDR_DEFORESTATION',
};

const CANONICAL_BY_VALUE = {
  LOCAL_DB_COMPLIANCE: DDS_MITIGATION_SOURCE_TYPE.LOCAL_DB_COMPLIANCE,
  local_db_compliance: DDS_MITIGATION_SOURCE_TYPE.LOCAL_DB_COMPLIANCE,
  EUDR_DEFORESTATION: DDS_MITIGATION_SOURCE_TYPE.EUDR_DEFORESTATION,
  eudr_deforestation: DDS_MITIGATION_SOURCE_TYPE.EUDR_DEFORESTATION,
};

/** Normalize GraphQL enum keys and DB values to canonical snake_case. */
export function normalizeMitigationSourceType(value) {
  if (!value) return null;
  return CANONICAL_BY_VALUE[value] ?? null;
}

/** Convert canonical value to NestJS GraphQL MitigationSourceType enum key. */
export function toGraphqlMitigationSourceType(value) {
  const canonical = normalizeMitigationSourceType(value);
  if (!canonical) return null;
  return GRAPHQL_ENUM_BY_CANONICAL[canonical];
}

export function filterMitigationFilesBySource(files, sourceType) {
  if (!Array.isArray(files)) return [];
  if (sourceType === 'other') {
    return files.filter((file) => !normalizeMitigationSourceType(file?.mitigation_source_type));
  }
  const canonical = normalizeMitigationSourceType(sourceType) ?? sourceType;
  return files.filter(
    (file) => normalizeMitigationSourceType(file?.mitigation_source_type) === canonical,
  );
}

export function countMitigationFilesBySource(files, sourceType) {
  return filterMitigationFilesBySource(files, sourceType).length;
}

export function hasUntypedMitigationFiles(files) {
  return countMitigationFilesBySource(files, 'other') > 0;
}
